import { NotFoundError } from "./NotFoundError.js";
class RepositoryNotFoundError extends NotFoundError {}
export { RepositoryNotFoundError };
